import React from "react";

interface FileExportImageProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const FileExportImage = ({
  color = "currentColor",
  size = 24,
  ...props
}: FileExportImageProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth={2}
    {...props}
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="18" x2="12" y2="12" />
    <polyline points="9 15 12 12 15 15" />
  </svg>
);

export default FileExportImage;
